<p class="mt-6 text-sm text-center text-gray-500 sm:px-10">
	I confirm that I am submitting a genuine review, and I agree with Uni Compare's
	<a routerLink="/terms" class="underline blue-link" target="_blank">Terms</a>
	and
	<a routerLink="/privacy" class="underline blue-link" target="_blank">Privacy Policy</a
	>.
</p>
